export default __webpack_public_path__ + "static/media/CNo.91-3.7bc45309.jpg";